const getRevelersByType = (type) => document.querySelectorAll(`[data-reveler-type='${type}']`);

const show = (classList, filterType) => {
  const revelers = Array.from(getRevelersByType(filterType));

  classList.remove('rev-Button--white');
  for (let i = 0; i < revelers.length; i++) {
    revelers[i].classList.add('show')
  }
}

const hide = (classList, filterType) => {
  const revelers = Array.from(getRevelersByType(filterType));

  classList.add('rev-Button--white');
  for (let i = 0; i < revelers.length; i++) {
    revelers[i].classList.remove('show')
  }
}

const hideOrShow = (element, filterType) => element.contains('rev-Button--white') ? show(element, filterType) : hide(element, filterType)

const initiateRevelers = () => {
  const revelers = document.getElementsByClassName('reveler');

  for (let i = 0; i < revelers.length; i++) {
    revelers[i].classList.add('show')
  }
}

export default {
  mounted() {
    initiateRevelers()

    this.el.addEventListener('filter', (e) => {
      const filterType = e.detail.resource_type;
      const element = this.el.classList;

      hideOrShow(element, filterType)
    });
  },
};
